// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { HostListener } from '@angular/core';
import { OverlayHelper, overlayUserConfiguration } from '../../overlayHelperClass';
import { ErrorModalBrokenClass } from './error-modal';

export class ErrorBrokenModalContructor {
	private errorBrokenModalOverlay: OverlayHelper;

	constructor(private overlay: Overlay) {
		this.errorBrokenModalOverlay = new OverlayHelper(overlay);

		const config: overlayUserConfiguration = {
			positionStrategy: 'fixed',
			scrollStrategy: 'close',
		};

		this.errorBrokenModalOverlay.setConfiguration(config);
	}

	public showComponente() {
		this.errorBrokenModalOverlay.show(ErrorModalBrokenClass);
		this.errorBrokenModalOverlay.actualizeData('setCallBackClose', this.callBackClose);
	}

	public callBackClose = () => {
		this.errorBrokenModalOverlay.close();
	};
}
